import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Accordion } from 'react-bootstrap';

const FAQSection = () => {

  const [activeKey, setActiveKey] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const key = location.hash.replace('#', '');
    if (key) setActiveKey(key);
  }, [location.hash]);


  return (
    <section className="my-5 faq-section">
      <Accordion activeKey={activeKey} onSelect={(k) => setActiveKey(k)}>

        <Accordion.Item eventKey="faq-who">
          <Accordion.Header>Для кого ця послуга?</Accordion.Header>
          <Accordion.Body>
            <p>Послуга призначена для батьків або законних представників дітей, які бажають подати електронну заяву на зарахування дитини до закладу дошкільної освіти міста Києва.</p>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="faq-how">
          <Accordion.Header>Як скористатися послугою?</Accordion.Header>
          <Accordion.Body>
            <p>Увійдіть до Системи за допомогою електронної ідентифікації, заповніть дані про дитину, оберіть заклад дошкільної освіти та подайте електронну заяву. Статус заяви можна відстежувати в особистому кабінеті.</p>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="questionauth" id="questionauth">
          <Accordion.Header>Як увійти до Системи?</Accordion.Header>
          <Accordion.Body>
            <p>Натисніть кнопку «Увійти».</p>
            <p>Ви будете перенаправлені до Модуля авторизації — натисніть «Перейти на головну»</p>
            <p>Оберіть зручний спосіб ідентифікації:</p>
            <ul>
              <li>BankID</li>
              <li>Дія</li>
              <li>КЕП</li>
            </ul>
            <p>Підтвердьте свою особу</p>
            <p>Вкажіть контактні дані:</p>
            <ul>
              <li>електронну пошту</li>
              <li>номер телефону</li>
            </ul>
            <p>⚠️ Якщо у вас вже є профіль у СЕЗ ЗДО, обов’язково використовуйте ту електронну пошту, яку ви зазначали раніше. Після цього поверніться на початкову сторінку <a href="https://osvita.kyivcity.gov.ua">https://osvita.kyivcity.gov.ua</a>, натисніть «Увійти» і авторизуйтесь обраним способом.</p>
            <p>✅ Для зручності користувачів доступна <a href='https://youtu.be/l80xUyzgp04?is=UIpT8bya8Fg9TIxr'>відеоінструкція</a> з покроковим поясненням процесу входу до Системи.</p>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="faq-legal">
          <Accordion.Header>Правове обґрунтування</Accordion.Header>
          <Accordion.Body>
            <p>Послуга надається відповідно до законодавства України у сфері дошкільної освіти та рішень органів місцевого самоврядування міста Києва щодо організації електронного запису дітей до закладів дошкільної освіти.</p>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="faq-reject">
          <Accordion.Header>Можливі причини відмови</Accordion.Header>
          <Accordion.Body>
            <p>Відмова можлива у разі подання недостовірних або неповних даних, відсутності вільних місць у вибраному закладі, невідповідності віку дитини вимогам групи або подання дублюючих заяв.</p>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="faq-after">
          <Accordion.Header>Що відбувається після подання заяви?</Accordion.Header>
          <Accordion.Body>
            <p>Після подання заяви Система автоматично реєструє її та ставить дитину в електронну чергу до обраного закладу дошкільної освіти.</p>
            <p>Якщо зазначено пільгу,  вона підлягає перевірці. Після підтвердження пільги місце дитини в черзі може змінитися відповідно до пріоритетів.</p>
            <p>Коли підходить черга і є вільні місця, заклад розглядає заяву та приймає рішення про зарахування або відмову.</p>
            <p>Про всі зміни статусу батьки отримують повідомлення в особистому кабінеті та на електронну пошту.</p>
            <p>У разі зарахування батькам потрібно вчасно подати необхідні документи та виконати подальші вимоги закладу.</p>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="faq-video">
          <Accordion.Header>Відеоінструкція</Accordion.Header>
          <Accordion.Body>
            <p>Покрокове пояснення процесу подання електронної заяви до закладу дошкільної освіти через Систему. Перегляньте <a href="https://youtu.be/5tsvSGsgDGk?si=3kfV-97l_rBLzcSE">відео</a>, щоб швидко та правильно оформити заяву для зарахування дитини.</p>
          </Accordion.Body>
        </Accordion.Item>

        <Accordion.Item eventKey="faq-finans">
          <Accordion.Header>Порядок фінансування та оплати за дитячий садок</Accordion.Header>
          <Accordion.Body>
            <p>За <a href='https://kmr.ligazakon.net/document/mr181524$2023_01_01'>посиланням</a> Ви можете ознайомитись із Порядком фінансування дошкільної освіти у місті Києві на основі базового фінансового нормативу (БФН). Документ містить інформацію про те, хто має право на фінансування за рахунок бюджету міста, у яких випадках сплачується БФН та які категорії дітей і батьків мають пільги або звільняються від оплати</p>
          </Accordion.Body>
        </Accordion.Item>


        

        <Accordion.Item eventKey="techAssistance">
          <Accordion.Header>Технічна підтримка</Accordion.Header>
          <Accordion.Body>
            <p>Пошта: support.osvita@kyivcity.gov.ua</p>
            <p>Телефон: (044) 366-80-15</p>
            <p>Група підтримки в мережі <a href="https://www.facebook.com/groups/192397261645593/?ref=bookmarks">Facebook</a></p>
          </Accordion.Body>
        </Accordion.Item>

      </Accordion>
    </section>
  );
};

export default FAQSection;